/**
 * Single source of truth for secteurs (zones).
 * Used by main.js (filter) and post.html (zone select).
 */
export function getSecteurs() {
    return [
        'Bras-Panon',
        'Cilaos',
        'Entre-Deux',
        'L\'Étang-Salé',
        'La Plaine-des-Palmistes',
        'La Possession',
        'Le Port',
        'Le Tampon',
        'Les Avirons',
        'Les Trois-Bassins',
        'Petite-Île',
        'Salazie',
        'Saint-André',
        'Saint-Benoît',
        'Saint-Denis',
        'Saint-Joseph',
        'Saint-Leu',
        'Saint-Louis',
        'Saint-Paul',
        'Saint-Philippe',
        'Saint-Pierre',
        'Sainte-Marie',
        'Sainte-Rose',
        'Sainte-Suzanne'
    ];
}
